/*
 * @Description:
 */
import 'lib-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import * as Sentry from '@dida-sentry/h5'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
import { BsGetCid, BsGetEnv, BsSetWebp, BsTrack, BsTrackExp, VnToast } from 'dida-web-common'

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual'
}

Vue.config.productionTip = false
Vue.use(VnToast)

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      Vue,
      release: packageInfo.name + '@' + packageInfo.version,
      environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
      dsn: 'https://c6f64916af8c449d9d90693ffc0b5ea7@sentry.didapinche.com/1528',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
        })
      ],
      tracesSampleRate: 1.0
    })
  } catch (e) {
    console.warn('sentry 加载失败！', e)
  }
}

(async function() {
  await BsSetWebp.init(Vue)
  const { cid } = await BsGetCid()
  Vue.prototype.$track = new BsTrack({ name: packageInfo.name, cid }, {})
  Vue.directive('exposure', BsTrackExp)

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
})()
